import { ScheduleActionsCancel } from "./Cancel";
import { ScheduleActionsComplete } from "./Complete";
import { ScheduleActionsDelete } from "./Delete";
import { ScheduleActionsMoveStage } from "./MoveStage";
import { ScheduleActionsPause } from "./Pause";
import { ScheduleActionsProvider } from "./Provider";
import { ScheduleActionsReschedule } from "./Reschedule";
import { ScheduleActionsResume } from "./Resume";
import { ScheduleActionsStart } from "./Start";
import { ScheduleActionsUnpause } from "./Unpause";

export const ScheduleActions = {
  Provider: ScheduleActionsProvider,
  MoveStage: ScheduleActionsMoveStage,
  Reschedule: ScheduleActionsReschedule,
  Delete: ScheduleActionsDelete,
  Pause: ScheduleActionsPause,
  Resume: ScheduleActionsResume,
  Start: ScheduleActionsStart,
  Unpause: ScheduleActionsUnpause,
  Complete: ScheduleActionsComplete,
  Cancel: ScheduleActionsCancel,
};
